import {Pipe, PipeTransform} from "@angular/core";
import {CurrencyPipe} from "@angular/common";
import {map, Observable} from "rxjs";
import {BusinessI18nService} from "@core/libs";

@Pipe({
  name: 'currencyAmountI18n',
  standalone: false
})
export class CurrencyAmountI18nPipe implements PipeTransform {
  constructor(
    private currencyPipe: CurrencyPipe,
    private businessI18nService: BusinessI18nService,
  ) {
  }

  transform(value: any): Observable<string | null> {
    return this.businessI18nService.configs$.pipe(
      map(configs => {
        if (!this.isValidNumber(value)) {
          return null;
        }

        let symbolDisplay: string = '';
        if (configs.currency.display != 'none') {
          symbolDisplay = configs.currency.display
        }

        return this.currencyPipe.transform(
          value,
          configs.currency.code,
          symbolDisplay,
          undefined,
          configs.locale
        );
      })
    );
  }


  private isValidNumber(value: any): boolean {
    const isValidNumber = typeof value === 'number' && !isNaN(value);
    const isValidString = (typeof value === 'string' && !isNaN(parseFloat(value)));
    return isValidNumber || isValidString;
  }
}
